import { GameData } from "../gamestate/gameData";
import { GetWinlineCombo } from "../inGameFunction";
import { createMovieClip } from "../../../common/functions/Functions_General";
import { convertCreditsFromServerToClient } from "../../../common/datastructures/Credits";

export class WinLineBuilder {
  private winLinesframes: Array<PIXI.extras.AnimatedSprite>; //all frames
  private winLineslines: Array<PIXI.Sprite>; //all lines
  private winframes: Array<Array<PIXI.extras.AnimatedSprite>>; // contains alll winlines possible 0 to 5
  private parent: PIXI.Container;
  private winDic: Array<number>;
  private key: Array<number>;
  private value: Array<number>;
  private totalCycles: number;
  private currentCycle: number;
  private lineMaskTwo: PIXI.Graphics;
  private lineMaskThree: PIXI.Graphics;
  private lineMaskFour: PIXI.Graphics;
  private lineMaskFive: PIXI.Graphics;

  //--
  //--
  private lineMaskEightteen_three: PIXI.Graphics;
  private lineMaskEightteen_four: PIXI.Graphics;
  private lineMaskEightteen_five: PIXI.Graphics;
  //--
  private lineMaskNineteen_three: PIXI.Graphics;
  private lineMaskNineteen_four: PIXI.Graphics;
  private lineMaskNineteen_five: PIXI.Graphics;
  //--
  private lineMaskTwenty_three: PIXI.Graphics;
  private lineMaskTwenty_four: PIXI.Graphics;
  private lineMaskTwenty_five: PIXI.Graphics;


  //--
  private lineMaskTwentyThree_three: PIXI.Graphics;
  private lineMaskTwentyThree_four: PIXI.Graphics;
  private lineMaskTwentyThree_five: PIXI.Graphics;

  // //--
  // private lineMaskTwenty_three: PIXI.Graphics;
  // private lineMaskTwenty_four: PIXI.Graphics;
  // private lineMaskTwenty_five: PIXI.Graphics;

  private lineMasks: Array<PIXI.Graphics>;
  private swapTicker: PIXI.ticker.Ticker;
  private switchTimer: number;
  private linesContainer: PIXI.Container;
  private linesNumberContainer: PIXI.Container;
  private activeGameData: GameData;
  private counter: number;
  private switchSpeed: number; //swipe alpha between diffrent winlines;
  private winFramStyleIndex: number; //0 is square frame and 1 is circle frame
  private winlines: Array<Array<PIXI.Sprite>>;

  private winlineNumberL: PIXI.Text;
  private winlineNumberR: PIXI.Text;

  private winValueDisplay: PIXI.Text;

  private winValueDisplayTween: PIXI.tween.Tween;

  //-number  displayer
  private winLinesNumberBG_R:PIXI.Sprite;

  private winLinesNumberBG_L:PIXI.Sprite;


  private winlineNumStyle: PIXI.TextStyle;
  private winAmountStyle:PIXI.TextStyle;
  constructor(parent: PIXI.Container, activeGameData: GameData) {
    this.winLinesframes = []; //all frames
    this.winLineslines = []; //all lines
    this.activeGameData = activeGameData;
    this.winframes = []; // contains alll winlines possible 0 to 5
    this.winlines = [];
    this.parent = new PIXI.Container();
    parent.addChild(this.parent);

    if (activeGameData.isMobile) {
      this.parent.x = -95;
      this.parent.y = -55;
      this.parent.scale.set(activeGameData.gameScale);
      this.parent.scale.set(270 / 213);
    } else {
      this.parent.scale.set(this.activeGameData.cardsize / 213);
      if (this.activeGameData.cardsize != 213) {
        this.parent.x = -95;
        this.parent.y = -55;
      }
    }
    this.winDic;
    this.key = [];
    this.value = [];

    this.totalCycles = 0;
    this.currentCycle = 0;

    this.winFramStyleIndex = 0; //0 is square frame and 1 is circle frame

    // this.lineMaskTwo;
    // this.lineMaskThree;
    // this.lineMaskFour;
    // this.lineMaskFive;
    // this.lineMasks;
    this.swapTicker = new PIXI.ticker.Ticker();
    this.switchSpeed = 700; //swipe alpha between diffrent winlines;
    this.switchTimer = 0;
    this.swapTicker.stop();
    
    this.linesContainer = new PIXI.Container();
    this.createLines();
    this.linesNumberContainer = new PIXI.Container();
    this.createWinlineNums();
  
    this.createBoxes();
  }

  private createWinlineNums = (): void => {
    this.winlineNumStyle = new PIXI.TextStyle({
      align: "center",      
      fontFamily:this.activeGameData.gameTextStyle.gameFont,  

      dropShadow: true,
      dropShadowBlur: 8,
      dropShadowColor: "#ffdc2e",
      dropShadowDistance: 0,
      fill: "white",
      fontSize: 50,
      fontWeight: "lighter",
      lineJoin: "bevel",
      miterLimit: 56,
      stroke: "#ffae00"
      
    });


    this.winAmountStyle = new PIXI.TextStyle({
      align: "center",
      dropShadow: true,
      dropShadowAngle: Math.PI/2,
      dropShadowBlur: 20,
      dropShadowColor: "#000000",
      dropShadowDistance: 0,
      fill: "white",
      fillGradientStops: [0, 0.5, 1],
      fontFamily: this.activeGameData.gameTextStyle.gameFont,
      fontSize: 50,
      //   fontWeight: "bolder",
      lineHeight: 27,
      stroke:"#ffc800",
      strokeThickness: 5,
      trim: true,
    });

    //-90 -290

    // let linesNumberParent=new PIXI.Container();
    this.linesNumberContainer.y=11
    this.parent.addChild(this.linesNumberContainer);
    this.winlineNumberL = new PIXI.Text("", this.winlineNumStyle);
    this.winlineNumberL.position.set(265+35, this.activeGameData.size[1]/2-90+200);
    this.winlineNumberL.anchor.set(0.5);


    

    this.winLinesNumberBG_L=new PIXI.Sprite( PIXI.Texture.fromFrame("FrameWinlinesNumber.png"));
    this.winLinesNumberBG_L.anchor.set(.5);

    this.winLinesNumberBG_L.position=this.winlineNumberL.position;
    // this.winLinesNumberBG_L.scale.set(.75);
    this.winLinesNumberBG_L.x-= this.winLinesNumberBG_L.width/2;
    this.winlineNumberL.x-= this.winLinesNumberBG_L.width/2;
    this.linesNumberContainer.addChild(this.winLinesNumberBG_L);

    this.linesNumberContainer.addChild(this.winlineNumberL);

    this.winlineNumberR = new PIXI.Text("", this.winlineNumStyle);
    this.winlineNumberR.anchor.set(0.5);
    this.winlineNumberR.position.set(
    1400-35,
      this.winlineNumberL.y 
    );


    this.winLinesNumberBG_R=new PIXI.Sprite( PIXI.Texture.fromFrame("FrameWinlinesNumber.png"));
    this.winLinesNumberBG_R.anchor.set(.5);

    this.winLinesNumberBG_R.position=this.winlineNumberR.position;
    this.winLinesNumberBG_R.x+= this.winLinesNumberBG_R.width/2;
    this.winlineNumberR.x+= this.winLinesNumberBG_R.width/2;
    this.linesNumberContainer.addChild(this.winLinesNumberBG_R);

    this.linesNumberContainer.addChild(this.winlineNumberR);  
     
      


    //-create tween;

    this.winValueDisplay = new PIXI.Text("-", this.winAmountStyle);
    this.winValueDisplay.position.set(
      this.activeGameData.size[0] / 2,
      1080 / 2 + 25
    );
    this.winValueDisplay.anchor.set(0.5);
    // this.parent.addChild(this.winValueDisplay);

    this.winValueDisplayTween = PIXI.tweenManager.createTween(this.winValueDisplay);
    this.winValueDisplayTween
      .from({ scale: { x: 2.5, y: 2.5 },alpha:0 })
      .to({ scale: { x: 1, y: 1 },alpha:1});
    this.winValueDisplayTween.time = 500;
    // this.winValueDisplayTween.delay = 2500;
    this.winValueDisplayTween.loop = false;
    this.winValueDisplayTween.easing = PIXI.tween.Easing.outBack();

    // this.winValueDisplayTween.start();

    this.setWinlinesNumVisible(false);
  };

  private createBoxes = (): void => {
    //Create winlinesBoxes
    let col = 0;
		let row = 0;
		for (var i = 0; i < 15; i++) {
			this.winLinesframes[i] = createMovieClip("frameWinAnim", 0, 21)
			// this.winLinesframes[i]=new PIXI.Sprite(PIXI.Texture.fromImage("winFrameFrame.png"));//STATIC
			// this.winLinesframes[i]=createMovieClip("winFrameFrame",0,24)
			this.winLinesframes[i].width = 300;
			this.winLinesframes[i].height = 300;
			// this.winLinesframes[i].play();
			this.winLinesframes[i].loop=true;
			this.winLinesframes[i].alpha = 10;

			this.winLinesframes[i].x = 304 + 210 * col - 33 -9;
			this.winLinesframes[i].y = 136+ 213 * row - 33 - 12;
			this.winLinesframes[i].blendMode = PIXI.BLEND_MODES.SCREEN;
			//  this.winLinesframes[i].blendMode = PIXI.BLEND_MODES.ADD;//	.blendMode = PIXI.BLENDMODES.ADD;
			row++;
			if (row >= 3) {
				col++;
				row = 0;
			}

			this.parent.addChild(this.winLinesframes[i]);}

    //assign to corresponding winlines
    //
    this.winframes[0] = null; //emptyFirstIndex
    this.winframes[1] = [
      this.winLinesframes[1],
      this.winLinesframes[4],
      this.winLinesframes[7],
      this.winLinesframes[10],
      this.winLinesframes[13],
    ];
    this.winframes[2] = [
      this.winLinesframes[0],
      this.winLinesframes[3],
      this.winLinesframes[6],
      this.winLinesframes[9],
      this.winLinesframes[12],
    ];
    this.winframes[3] = [
      this.winLinesframes[2],
      this.winLinesframes[5],
      this.winLinesframes[8],
      this.winLinesframes[11],
      this.winLinesframes[14],
    ];
    this.winframes[4] = [
      this.winLinesframes[0],
      this.winLinesframes[4],
      this.winLinesframes[8],
      this.winLinesframes[10],
      this.winLinesframes[12],
    ];
    this.winframes[5] = [
      this.winLinesframes[2],
      this.winLinesframes[4],
      this.winLinesframes[6],
      this.winLinesframes[10],
      this.winLinesframes[14],
    ];

    //new winlines
    //
    this.winframes[6] = [
      this.winLinesframes[0],
      this.winLinesframes[3],
      this.winLinesframes[7],
      this.winLinesframes[11],
      this.winLinesframes[14],
    ];
    this.winframes[7] = [
      this.winLinesframes[2],
      this.winLinesframes[5],
      this.winLinesframes[7],
      this.winLinesframes[9],
      this.winLinesframes[12],
    ];
    //
    this.winframes[8] = [
      this.winLinesframes[1],
      this.winLinesframes[5],
      this.winLinesframes[8],
      this.winLinesframes[11],
      this.winLinesframes[13],
    ];
    this.winframes[9] = [
      this.winLinesframes[1],
      this.winLinesframes[3],
      this.winLinesframes[6],
      this.winLinesframes[9],
      this.winLinesframes[13],
    ];

    //
    this.winframes[10] = [
      this.winLinesframes[0],
      this.winLinesframes[4],
      this.winLinesframes[7],
      this.winLinesframes[10],
      this.winLinesframes[12],
    ];
    this.winframes[11] = [
      this.winLinesframes[2],
      this.winLinesframes[4],
      this.winLinesframes[7],
      this.winLinesframes[10],
      this.winLinesframes[14],
    ];
    //
    this.winframes[12] = [
      this.winLinesframes[1],
      this.winLinesframes[5],
      this.winLinesframes[7],
      this.winLinesframes[9],
      this.winLinesframes[13],
    ];
    this.winframes[13] = [
      this.winLinesframes[1],
      this.winLinesframes[3],
      this.winLinesframes[7],
      this.winLinesframes[11],
      this.winLinesframes[13],
    ];
    //-
    this.winframes[14] = [
      this.winLinesframes[0],
      this.winLinesframes[4],
      this.winLinesframes[6],
      this.winLinesframes[10],
      this.winLinesframes[12],
    ];
    this.winframes[15] = [
      this.winLinesframes[2],
      this.winLinesframes[4],
      this.winLinesframes[8],
      this.winLinesframes[10],
      this.winLinesframes[14],
    ];
    //
    this.winframes[16] = [
      this.winLinesframes[1],
      this.winLinesframes[4],
      this.winLinesframes[8],
      this.winLinesframes[10],
      this.winLinesframes[13],
    ];
    this.winframes[17] = [
      this.winLinesframes[1],
      this.winLinesframes[4],
      this.winLinesframes[6],
      this.winLinesframes[10],
      this.winLinesframes[13],
    ];
    //
    this.winframes[18] = [
      this.winLinesframes[0],
      this.winLinesframes[5],
      this.winLinesframes[6],
      this.winLinesframes[11],
      this.winLinesframes[12],
    ];
    this.winframes[19] = [
      this.winLinesframes[2],
      this.winLinesframes[3],
      this.winLinesframes[8],
      this.winLinesframes[9],
      this.winLinesframes[14],
    ];
    //
    this.winframes[20] = [
      this.winLinesframes[1],
      this.winLinesframes[3],
      this.winLinesframes[8],
      this.winLinesframes[9],
      this.winLinesframes[13],
    ];


    this.winframes[21] = [
      this.winLinesframes[1],
      this.winLinesframes[5],
      this.winLinesframes[6],
      this.winLinesframes[11],
      this.winLinesframes[13],
    ];

    this.winframes[22] = [
      this.winLinesframes[0],
      this.winLinesframes[3],
      this.winLinesframes[8],
      this.winLinesframes[9],
      this.winLinesframes[12],
    ];

    this.winframes[23] = [
      this.winLinesframes[2],
      this.winLinesframes[5],
      this.winLinesframes[6],
      this.winLinesframes[11],
      this.winLinesframes[14],
    ];

    this.winframes[24] = [
      this.winLinesframes[0],
      this.winLinesframes[5],
      this.winLinesframes[8],
      this.winLinesframes[11],
      this.winLinesframes[12],
    ];
    this.winframes[25] = [
      this.winLinesframes[2],
      this.winLinesframes[3],
      this.winLinesframes[6],
      this.winLinesframes[9],
      this.winLinesframes[14],
    ];
  };
  private createLines = (): void => {
    this.parent.addChild(this.linesContainer);
    this.linesContainer.x=-125;
    this.linesContainer.y=-110//11;
    //Create Winlines  2
    this.winLineslines[0] = new PIXI.Sprite(PIXI.Texture.fromImage("wl_0.png"));
    this.winLineslines[0].x =
      this.activeGameData.size[0] / 2 - this.winLineslines[0].width / 2; //230;;
    this.winLineslines[0].y = 107 + 130;
    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[1] = new PIXI.Sprite(PIXI.Texture.fromImage("wl_0.png"));

    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[1].scale.set(-1, 1);
    this.winLineslines[1].x =
      this.winLineslines[0].x + this.winLineslines[0].width - 0.25;
    // this.winLineslines[0].x + this.winLineslines[0].width * 2-offsetX;
    this.winLineslines[1].y = this.winLineslines[0].y;
    this.linesContainer.addChild(this.winLineslines[0]);
    this.linesContainer.addChild(this.winLineslines[1]);

    //Create Winlines  1
    this.winLineslines[2] = new PIXI.Sprite(PIXI.Texture.fromImage("wl_0.png"));
    this.winLineslines[2].x = this.winLineslines[0].x;
    this.winLineslines[2].y = 135 + 187 + 130;
    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[3] = new PIXI.Sprite(PIXI.Texture.fromImage("wl_0.png"));
    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[3].scale.set(-1, 1);
    this.winLineslines[3].x = this.winLineslines[1].x;
    this.winLineslines[3].y = this.winLineslines[2].y;
    this.linesContainer.addChild(this.winLineslines[2]);
    this.linesContainer.addChild(this.winLineslines[3]);

    //Create Winlines  3
    this.winLineslines[4] = new PIXI.Sprite(PIXI.Texture.fromImage("wl_0.png"));
    this.winLineslines[4].x = this.winLineslines[0].x;
    this.winLineslines[4].y = 545 - 10 + 130;
    // this.winLineslins[0].anchor.set(0.5)
    this.winLineslines[5] = new PIXI.Sprite(PIXI.Texture.fromImage("wl_0.png"));
    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[5].scale.set(-1, 1);
    this.winLineslines[5].x = this.winLineslines[1].x;
    this.winLineslines[5].y = this.winLineslines[4].y;
    this.linesContainer.addChild(this.winLineslines[4]);
    this.linesContainer.addChild(this.winLineslines[5]);

    //Create Winlines  4
    this.winLineslines[6] = new PIXI.Sprite(PIXI.Texture.fromImage("wl_1.png"));
    this.winLineslines[6].x = this.winLineslines[0].x;
    this.winLineslines[6].y = 237;
    // this.winLineslins[0].anchor.set(0.5)
    this.winLineslines[7] = new PIXI.Sprite(PIXI.Texture.fromImage("wl_1.png"));
    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[7].scale.set(-1, 1);
    this.winLineslines[7].x = this.winLineslines[1].x - 0.25;
    this.winLineslines[7].y = this.winLineslines[6].y;
    this.linesContainer.addChild(this.winLineslines[6]);
    this.linesContainer.addChild(this.winLineslines[7]);

    //Create Winlines  5
    this.winLineslines[8] = new PIXI.Sprite(PIXI.Texture.fromImage("wl_1.png"));
    this.winLineslines[8].x = this.winLineslines[0].x;
    this.winLineslines[8].y = 135 + 760 - 19;
    this.winLineslines[8].scale.set(1, -1);
    // this.winLineslins[0].anchor.set(0.5)
    this.winLineslines[9] = new PIXI.Sprite(PIXI.Texture.fromImage("wl_1.png"));

    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[9].scale.set(-1, -1);
    this.winLineslines[9].x = this.winLineslines[1].x - 0.25;
    this.winLineslines[9].y = this.winLineslines[8].y;
    this.linesContainer.addChild(this.winLineslines[8]);
    this.linesContainer.addChild(this.winLineslines[9]);

    //Create Winlines  6
    let spriteName6 = "wl_2.png";
    this.winLineslines[10] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName6)
    );
    this.winLineslines[10].x = this.winLineslines[0].x;
    this.winLineslines[10].y = this.winLineslines[0].y;
    this.winLineslines[10].scale.set(1);
    // this.winLineslins[0].anchor.set(0.5)
    this.winLineslines[11] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName6)
    );

    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[11].scale.set(-1, -1);
    this.winLineslines[11].x = this.winLineslines[1].x;
    this.winLineslines[11].y = 135 + 760 - 20; //this.winLineslines[10].y;
    this.linesContainer.addChild(this.winLineslines[10]);
    this.linesContainer.addChild(this.winLineslines[11]);

    //Create Winlines  7
    let spriteName7 = "wl_2.png";
    this.winLineslines[12] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName7)
    );
    this.winLineslines[12].x = this.winLineslines[0].x;
    this.winLineslines[12].y =
      this.winLineslines[0].y + this.winLineslines[12].height + 25;
    this.winLineslines[12].scale.set(1, -1);
    // this.winLineslins[0].anchor.set(0.5)
    this.winLineslines[13] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName7)
    );

    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[13].scale.set(-1, 1);
    this.winLineslines[13].x = this.winLineslines[1].x;
    this.winLineslines[13].y = this.winLineslines[0].y + 1; // 135 + 760-20;//this.winLineslines[10].y;
    this.linesContainer.addChild(this.winLineslines[12]);
    this.linesContainer.addChild(this.winLineslines[13]);

    //Create Winlines  8
    let spriteName8 = "wl_3.png";
    this.winLineslines[14] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName8)
    );
    this.winLineslines[14].x = this.winLineslines[0].x;
    this.winLineslines[14].y = this.winLineslines[0].y + 215;
    this.winLineslines[14].scale.set(1);
    // this.winLineslins[0].anchor.set(0.5)
    this.winLineslines[15] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName8)
    );

    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[15].scale.set(-1, 1);
    this.winLineslines[15].x = this.winLineslines[1].x;
    this.winLineslines[15].y = this.winLineslines[0].y + 215; // 135 + 760-20;//this.winLineslines[10].y;
    this.linesContainer.addChild(this.winLineslines[14]);
    this.linesContainer.addChild(this.winLineslines[15]);

    //Create Winlines  9
    let spriteName9 = "wl_3.png";
    this.winLineslines[16] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName9)
    );
    this.winLineslines[16].x = this.winLineslines[0].x;
    this.winLineslines[16].y =
      this.winLineslines[0].y + this.winLineslines[12].height - 187;
    this.winLineslines[16].scale.set(1, -1);
    // this.winLineslins[0].anchor.set(0.5)
    this.winLineslines[17] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName9)
    );

    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[17].scale.set(-1, -1);
    this.winLineslines[17].x = this.winLineslines[1].x;
    this.winLineslines[17].y = this.winLineslines[16].y; //this.winLineslines[0].y+215*2// 135 + 760-20;//this.winLineslines[10].y;
    this.linesContainer.addChild(this.winLineslines[16]);
    this.linesContainer.addChild(this.winLineslines[17]);

    //Create Winlines  10
    // let spriteName8="wl_3.png";
    this.winLineslines[18] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName8)
    );
    this.winLineslines[18].x = this.winLineslines[0].x;
    this.winLineslines[18].y = this.winLineslines[0].y;
    this.winLineslines[18].scale.set(1);
    // this.winLineslins[0].anchor.set(0.5)
    this.winLineslines[19] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName8)
    );

    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[19].scale.set(-1, 1);
    this.winLineslines[19].x = this.winLineslines[1].x;
    this.winLineslines[19].y = this.winLineslines[0].y; // 135 + 760-20;//this.winLineslines[10].y;
    this.linesContainer.addChild(this.winLineslines[18]);
    this.linesContainer.addChild(this.winLineslines[19]);

    //Create Winlines  11


    // let spriteName10="wl_3.png";
    this.winLineslines[20] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName9)
    );
    this.winLineslines[20].x = this.winLineslines[0].x;
    this.winLineslines[20].y =
      this.winLineslines[0].y + this.winLineslines[12].height - 189 + 215;
    this.winLineslines[20].scale.set(1, -1);
    // this.winLineslins[0].anchor.set(0.5)
    this.winLineslines[21] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName9)
    );

    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[21].scale.set(-1, -1);
    this.winLineslines[21].x = this.winLineslines[1].x;
    this.winLineslines[21].y = this.winLineslines[20].y; //this.winLineslines[0].y+215*2// 135 + 760-20;//this.winLineslines[10].y;
    this.linesContainer.addChild(this.winLineslines[20]);
    this.linesContainer.addChild(this.winLineslines[21]);

    // //Create Winlines  -12
    // let spriteName12 = "wl_4.png";
    // this.winLineslines[22] = new PIXI.Sprite(
    //   PIXI.Texture.fromImage(spriteName12)
    // );
    // this.winLineslines[22].x = this.winLineslines[0].x;
    // this.winLineslines[22].y =
    //   this.winLineslines[0].y + this.winLineslines[12].height - 187;
    // this.winLineslines[22].scale.set(1, -1);
    // // this.winLineslins[0].anchor.set(0.5)
    // this.winLineslines[23] = new PIXI.Sprite(
    //   PIXI.Texture.fromImage(spriteName12)
    // );

    // // this.winLineslines[0].anchor.set(0.5)
    // this.winLineslines[23].scale.set(-1, 1);
    // this.winLineslines[23].x = this.winLineslines[1].x - 0.25;
    // this.winLineslines[23].y = this.winLineslines[0].y + 215 - 0.25; //this.winLineslines[0].y+215*2// 135 + 760-20;//this.winLineslines[10].y;
    // this.linesContainer.addChild(this.winLineslines[22]);
    // this.linesContainer.addChild(this.winLineslines[23]);

    //Create Winlines  -12
    let spriteName12 = "wl_4.png";
    // let spriteName12="wl_4.png";
    this.winLineslines[22] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName12)
    );
    this.winLineslines[22].x = this.winLineslines[0].x;
    this.winLineslines[22].y = this.winLineslines[0].y + 215 - 0.25;
    this.winLineslines[22].scale.set(1, 1);
    // this.winLineslins[0].anchor.set(0.5)
    this.winLineslines[23] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName12)
    );

    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[23].scale.set(-1, -1);
    this.winLineslines[23].x = this.winLineslines[1].x - 0.25;
    this.winLineslines[23].y =
      this.winLineslines[0].y + this.winLineslines[12].height - 189; //this.winLineslines[0].y+215*2// 135 + 760-20;//this.winLineslines[10].y;
    this.linesContainer.addChild(this.winLineslines[22]);
    this.linesContainer.addChild(this.winLineslines[23]);




    
    //Create Winlines  -13

    this.winLineslines[24] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName12)
    );
    this.winLineslines[24].x = this.winLineslines[0].x;
    this.winLineslines[24].y =
      this.winLineslines[0].y + this.winLineslines[12].height - 187;
    this.winLineslines[24].scale.set(1, -1);
    // this.winLineslins[0].anchor.set(0.5)
    this.winLineslines[25] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName12)
    );

    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[25].scale.set(-1, 1);
    this.winLineslines[25].x = this.winLineslines[1].x - 0.25;
    this.winLineslines[25].y = this.winLineslines[0].y + 215 - 0.25; //this.winLineslines[0].y+215*2// 135 + 760-20;//this.winLineslines[10].y;
    this.linesContainer.addChild(this.winLineslines[24]);
    this.linesContainer.addChild(this.winLineslines[25]);



    //Create Winlines  -14
    // let spriteName12="wl_4.png";
    this.winLineslines[26] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName12)
    );
    this.winLineslines[26].x = this.winLineslines[0].x;
    this.winLineslines[26].y = this.winLineslines[0].y;
    this.winLineslines[26].scale.set(1);
    // this.winLineslins[0].anchor.set(0.5)
    this.winLineslines[27] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName12)
    );

    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[27].scale.set(-1, 1);
    this.winLineslines[27].x = this.winLineslines[1].x - 0.25;
    this.winLineslines[27].y = this.winLineslines[0].y; //this.winLineslines[0].y+215*2// 135 + 760-20;//this.winLineslines[10].y;
    this.linesContainer.addChild(this.winLineslines[26]);
    this.linesContainer.addChild(this.winLineslines[27]);

    //Create Winlines  -15
    //  let spriteName12="wl_4.png";
    this.winLineslines[28] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName12)
    );
    this.winLineslines[28].x = this.winLineslines[0].x;
    this.winLineslines[28].y =
      this.winLineslines[0].y + this.winLineslines[12].height - 189 + 215;
    this.winLineslines[28].scale.set(1, -1);
    // this.winLineslins[0].anchor.set(0.5)
    this.winLineslines[29] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName12)
    );

    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[29].scale.set(-1, -1);
    this.winLineslines[29].x = this.winLineslines[1].x - 0.25;
    this.winLineslines[29].y =
      this.winLineslines[0].y + this.winLineslines[12].height - 189 + 215; //this.winLineslines[0].y+215*2// 135 + 760-20;//this.winLineslines[10].y;
    this.linesContainer.addChild(this.winLineslines[28]);
    this.linesContainer.addChild(this.winLineslines[29]);

    //Create Winlines  16

    let spriteName16 = "wl_4.2.png";
    this.winLineslines[30] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName16)
    );
    this.winLineslines[30].x =
      this.activeGameData.size[0] / 2 - this.winLineslines[0].width / 2; //230;;
    this.winLineslines[30].y = 107 + 130 + this.winLineslines[30].height + 19;
    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[30].scale.set(1, -1);
    this.winLineslines[31] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName16)
    );

    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[31].scale.set(-1, -1);
    this.winLineslines[31].x =
      this.winLineslines[0].x + this.winLineslines[0].width - 0.25;
    // this.winLineslines[0].x + this.winLineslines[0].width * 2-offsetX;
    this.winLineslines[31].y = this.winLineslines[30].y;
    this.linesContainer.addChild(this.winLineslines[30]);
    this.linesContainer.addChild(this.winLineslines[31]);

    // Create Winlines  17

    let spriteName17 = "wl_4.2.png";
    this.winLineslines[32] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName17)
    );
    this.winLineslines[32].x =
      this.activeGameData.size[0] / 2 - this.winLineslines[0].width / 2; //230;;
    this.winLineslines[32].y = this.winLineslines[0].y + 7;
    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[33] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName17)
    );

    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[33].scale.set(-1, 1);
    this.winLineslines[33].x =
      this.winLineslines[0].x + this.winLineslines[0].width - 0.25;
    // this.winLineslines[0].x + this.winLineslines[0].width * 2-offsetX;
    this.winLineslines[33].y = this.winLineslines[32].y;
    this.linesContainer.addChild(this.winLineslines[32]);
    this.linesContainer.addChild(this.winLineslines[33]);

    // Create Winlines  18

    let spriteName18 = "wl_5.png";
    this.winLineslines[34] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName18)
    );
    this.winLineslines[34].x =
      this.activeGameData.size[0] / 2 - this.winLineslines[0].width / 2; //230;;
    this.winLineslines[34].y = this.winLineslines[0].y;
    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[35] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName18)
    );

    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[35].scale.set(-1, 1);
    this.winLineslines[35].x =
      this.winLineslines[0].x + this.winLineslines[0].width - 0.25;
    // this.winLineslines[0].x + this.winLineslines[0].width * 2-offsetX;
    this.winLineslines[35].y = this.winLineslines[34].y;
    this.linesContainer.addChild(this.winLineslines[34]);
    this.linesContainer.addChild(this.winLineslines[35]);

    //Create Winlines  19

    this.winLineslines[36] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName18)
    );
    this.winLineslines[36].x =
      this.activeGameData.size[0] / 2 - this.winLineslines[0].width / 2; //230;;
    this.winLineslines[36].y = 107 + 130 + this.winLineslines[30].height + 26;
    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[36].scale.set(1, -1);
    this.winLineslines[37] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName18)
    );

    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[37].scale.set(-1, -1);
    this.winLineslines[37].x =
      this.winLineslines[0].x + this.winLineslines[0].width - 0.25;
    // this.winLineslines[0].x + this.winLineslines[0].width * 2-offsetX;
    this.winLineslines[37].y = this.winLineslines[36].y;
    this.linesContainer.addChild(this.winLineslines[36]);
    this.linesContainer.addChild(this.winLineslines[37]);



    //Create Winlines  20
    let spriteName20 = "wl_6.png";
    this.winLineslines[38] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName20)
    );

    this.winLineslines[38].x =
      this.activeGameData.size[0] / 2 - this.winLineslines[0].width / 2; //230;;
    this.winLineslines[38].y = 107 + 137;
    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[39] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName20)
    );

    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[39].scale.set(-1, 1);
    this.winLineslines[39].x =
      this.winLineslines[0].x + this.winLineslines[0].width - 0.25;
    // this.winLineslines[0].x + this.winLineslines[0].width * 2-offsetX;
    this.winLineslines[39].y = this.winLineslines[38].y;
    this.linesContainer.addChild(this.winLineslines[38]);
    this.linesContainer.addChild(this.winLineslines[39]);


    // + this.winLineslines[12].height - 187; this.winLineslines[0].y + 215; // 135 + 760-20;//this.winLineslines[10].y;
    //Create Winlines  21
    this.winLineslines[40] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName20)
    );

    this.winLineslines[40].x =
      this.activeGameData.size[0] / 2 - this.winLineslines[0].width / 2; //230;;
    this.winLineslines[40].y = 107 + 150+this.winLineslines[0].height ;
    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[40].scale.set(1, -1);
    this.winLineslines[41] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName20)
    );
  
    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[41].scale.set(-1, -1);
    this.winLineslines[41].x =
      this.winLineslines[0].x + this.winLineslines[0].width - 0.25;
    // this.winLineslines[0].x + this.winLineslines[0].width * 2-offsetX;
    this.winLineslines[41].y = this.winLineslines[40].y;
    this.linesContainer.addChild(this.winLineslines[40]);
    this.linesContainer.addChild(this.winLineslines[41]);

    

   
    //Create Winlines  22

    let spriteName21 = "wl_7.png";

    this.winLineslines[42] = new PIXI.Sprite(PIXI.Texture.fromImage(spriteName21));
    this.winLineslines[42].x =
      this.activeGameData.size[0] / 2 - this.winLineslines[0].width / 2; //230;;
    this.winLineslines[42].y = 107 + 130;
    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[43] = new PIXI.Sprite(PIXI.Texture.fromImage(spriteName21));

    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[43].scale.set(-1, 1);
    this.winLineslines[43].x =
      this.winLineslines[0].x + this.winLineslines[42].width - 0.25;
    // this.winLineslines[0].x + this.winLineslines[0].width * 2-offsetX;
    this.winLineslines[43].y = this.winLineslines[42].y;
    this.linesContainer.addChild(this.winLineslines[42]);
    this.linesContainer.addChild(this.winLineslines[43]);

    //Create Winlines  23

    // let spriteName10="wl_3.png";
    this.winLineslines[44] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName21)
    );
    this.winLineslines[44].x = this.winLineslines[0].x;
    this.winLineslines[44].y = 135 + 760 - 19;
    this.winLineslines[44].scale.set(1, -1);
    // this.winLineslins[0].anchor.set(0.5)
    this.winLineslines[45] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName21)
    );

    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[45].scale.set(-1, -1);
    this.winLineslines[45].x = this.winLineslines[1].x;
    this.winLineslines[45].y = this.winLineslines[44].y; //this.winLineslines[0].y+455*2// 135 + 760-44;//this.winLineslines[10].y;
    this.linesContainer.addChild(this.winLineslines[44]);
    this.linesContainer.addChild(this.winLineslines[45]);



    
   
    //Create Winlines  24

    let spriteName24 = "wl_8.png";

    this.winLineslines[46] = new PIXI.Sprite(PIXI.Texture.fromImage(spriteName24));
    this.winLineslines[46].x =
      this.activeGameData.size[0] / 2 - this.winLineslines[0].width / 2; //230;;
    this.winLineslines[46].y = 107 + 130;
    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[47] = new PIXI.Sprite(PIXI.Texture.fromImage(spriteName24));

    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[47].scale.set(-1, 1);
    this.winLineslines[47].x =
      this.winLineslines[0].x + this.winLineslines[46].width - 0.25;
    // this.winLineslines[0].x + this.winLineslines[0].width * 2-offsetX;
    this.winLineslines[47].y = this.winLineslines[46].y;
    this.linesContainer.addChild(this.winLineslines[46]);
    this.linesContainer.addChild(this.winLineslines[47]);

    //Create Winlines  25

    // let spriteName10="wl_3.png";
    this.winLineslines[48] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName24)
    );
    this.winLineslines[48].x = this.winLineslines[0].x;
    this.winLineslines[48].y = 135 + 760 - 19;
    this.winLineslines[48].scale.set(1, -1);
    // this.winLineslins[0].anchor.set(0.5)
    this.winLineslines[49] = new PIXI.Sprite(
      PIXI.Texture.fromImage(spriteName24)
    );

    // this.winLineslines[0].anchor.set(0.5)
    this.winLineslines[49].scale.set(-1, -1);
    this.winLineslines[49].x = this.winLineslines[1].x;
    this.winLineslines[49].y = this.winLineslines[48].y; //this.winLineslines[0].y+495*2// 135 + 760-48;//this.winLineslines[10].y;
    this.linesContainer.addChild(this.winLineslines[48]);
    this.linesContainer.addChild(this.winLineslines[49]);
    

    // this.winLineslines[48].tint=0xff0000;
    // this.winLineslines[49].tint=0xff0000;
    
    //  // + this.winLineslines[12].height - 187; this.winLineslines[0].y + 215; // 135 + 760-20;//this.winLineslines[10].y;
    // //Create Winlines  23
    // this.winLineslines[44] = new PIXI.Sprite(
    //   PIXI.Texture.fromImage(spriteName20)
    // );

    // this.winLineslines[44].x =
    //   this.activeGameData.size[0] / 2 - this.winLineslines[0].width / 2; //230;;
    // this.winLineslines[44].y = 107 + 150+this.winLineslines[0].height ;
    // // this.winLineslines[0].anchor.set(0.5)
    // this.winLineslines[44].scale.set(1, -1);
    // this.winLineslines[45] = new PIXI.Sprite(
    //   PIXI.Texture.fromImage(spriteName20)
    // );
  
    // // this.winLineslines[0].anchor.set(0.5)
    // this.winLineslines[45].scale.set(-1, -1);
    // this.winLineslines[45].x =
    //   this.winLineslines[0].x + this.winLineslines[0].width - 0.25;
    // // this.winLineslines[0].x + this.winLineslines[0].width * 2-offsetX;
    // this.winLineslines[45].y = this.winLineslines[44].y;
    // this.linesContainer.addChild(this.winLineslines[44]);
    // this.linesContainer.addChild(this.winLineslines[45]);


    ///------------assign winlines to a list

    this.winlines[1] = [this.winLineslines[2], this.winLineslines[3]];
    this.winlines[2] = [this.winLineslines[0], this.winLineslines[1]];
    this.winlines[3] = [this.winLineslines[4], this.winLineslines[5]];
    this.winlines[4] = [this.winLineslines[6], this.winLineslines[7]];
    this.winlines[5] = [this.winLineslines[8], this.winLineslines[9]];

    //- 20 lines
    this.winlines[6] = [this.winLineslines[10], this.winLineslines[11]];
    this.winlines[7] = [this.winLineslines[12], this.winLineslines[13]];
    this.winlines[8] = [this.winLineslines[14], this.winLineslines[15]];
    this.winlines[9] = [this.winLineslines[16], this.winLineslines[17]];
    this.winlines[10] = [this.winLineslines[18], this.winLineslines[19]];

    this.winlines[11] = [this.winLineslines[20], this.winLineslines[21]];
    this.winlines[12] = [this.winLineslines[22], this.winLineslines[23]];
    this.winlines[13] = [this.winLineslines[24], this.winLineslines[25]];
   this.winlines[14] = [this.winLineslines[26], this.winLineslines[27]];
    this.winlines[15] = [this.winLineslines[28], this.winLineslines[29]];

    this.winlines[16] = [this.winLineslines[30], this.winLineslines[31]];
    this.winlines[17] = [this.winLineslines[32], this.winLineslines[33]];
    this.winlines[18] = [this.winLineslines[34], this.winLineslines[35]];
    this.winlines[19] = [this.winLineslines[36], this.winLineslines[37]];
    this.winlines[20] = [this.winLineslines[38], this.winLineslines[39]];

    this.winlines[21] = [this.winLineslines[40], this.winLineslines[41]];
    this.winlines[22] = [this.winLineslines[42], this.winLineslines[43]];
    this.winlines[23] = [this.winLineslines[44], this.winLineslines[45]];
    this.winlines[24] = [this.winLineslines[46], this.winLineslines[47]];
    this.winlines[25] = [this.winLineslines[48], this.winLineslines[49]];


    //--
    // this.winLineslines[4].tint=0xff0000;
    // this.winLineslines[5].tint=0xff0000;
    for (var i = 1; i < this.winlines.length; i++) {
      // console.log(this.winlines.length)

      this.winlines[i][0].alpha = 0; //---default 0
      this.winlines[i][1].alpha = 0;
      // if(i==13)//12,13
      // { //test
      //   this.winlines[i][0].alpha = 1;//---default 0
      //   this.winlines[i][1].alpha = 1;
      // }

      this.winlines[i][1].blendMode = PIXI.BLEND_MODES.COLOR_DODGE;
      this.winlines[i][0].blendMode = PIXI.BLEND_MODES.COLOR_DODGE;

      //215px diffrence between lines
    }
    // console.log(this.winlines[2][0].y-this.winlines[1][0].y)
    //mask depening on winframe length


    let lineMaskContainer=new PIXI.Container();
    this.parent.addChild(lineMaskContainer);

    lineMaskContainer.x=-125;
    lineMaskContainer.y=-110//11;

    this.lineMaskTwo = new PIXI.Graphics();
    this.lineMaskTwo.beginFill(0x0033ff);
    this.lineMaskTwo.moveTo(220, 220);
    this.lineMaskTwo.lineTo(220, 900);
    this.lineMaskTwo.lineTo(230 + 194, 900);
    this.lineMaskTwo.lineTo(230 + 194, 240);

    this.lineMaskTwo.lineTo(835 + 20, 240); //--change this for diffrent masks
    this.lineMaskTwo.lineTo(835 + 20, 900); //--change this for diffrent masks
    this.lineMaskTwo.lineTo(1480 + 200, 900);
    this.lineMaskTwo.lineTo(1480 + 200, 220);
    this.lineMaskTwo.endFill();

    this.linesContainer.addChild(this.lineMaskTwo);
    this.lineMaskTwo.alpha = 0;

    this.lineMaskThree = new PIXI.Graphics();
    this.lineMaskThree.beginFill(0xff0000);
    this.lineMaskThree.moveTo(220, 220);
    this.lineMaskThree.lineTo(220, 900);
    this.lineMaskThree.lineTo(230 + 194, 900);
    this.lineMaskThree.lineTo(230 + 194, 240);


    this.lineMaskThree.lineTo(1050 + 14, 240); //--change this for diffrent masks
    this.lineMaskThree.lineTo(1050 + 14, 900); //--change this for diffrent masks
    this.lineMaskThree.lineTo(1480 + 200, 900);
    this.lineMaskThree.lineTo(1480 + 200, 220);
    this.lineMaskThree.endFill();
    this.linesContainer.addChild(this.lineMaskThree);
    this.lineMaskThree.alpha = 0;

    //---------Four

    this.lineMaskFour = new PIXI.Graphics();
    this.lineMaskFour = new PIXI.Graphics();
    this.lineMaskFour.beginFill(0xff0000);
    this.lineMaskFour.moveTo(240, 220);
    this.lineMaskFour.lineTo(240, 900);
    this.lineMaskFour.lineTo(230 + 194, 900);
    this.lineMaskFour.lineTo(230 + 194, 240);

    this.lineMaskFour.lineTo(1260 + 14, 240); //--change this for diffrent masks
    this.lineMaskFour.lineTo(1260 + 14, 900); //--change this for diffrent masks
    this.lineMaskFour.lineTo(1480 + 200, 900);
    this.lineMaskFour.lineTo(1480 + 200, 220);
    this.lineMaskFour.endFill();

    this.linesContainer.addChild(this.lineMaskFour);
    this.lineMaskFour.alpha = 0;

    // this.lineMaskFour.lineTo(230 + 200, 900);
    // this.lineMaskFour.lineTo(230 + 200, 240);
    //mask 5
    this.lineMaskFive = new PIXI.Graphics();
    this.lineMaskFive.beginFill(0x0033ff);
    this.lineMaskFive.moveTo(240, 220);
    this.lineMaskFive.lineTo(240, 900);
    this.lineMaskFive.lineTo(230 + 194, 900);
    this.lineMaskFive.lineTo(230 + 194, 240);

    this.lineMaskFive.lineTo(1480 + 12, 240);
    this.lineMaskFive.lineTo(1480 + 12, 900);
    this.lineMaskFive.lineTo(1480 + 200, 900);
    this.lineMaskFive.lineTo(1480 + 200, 220);
    this.lineMaskFive.endFill();

    this.linesContainer.addChild(this.lineMaskFive);
    this.lineMaskFive.alpha = 0;

    //----special masks 19

    this.lineMaskEightteen_three = new PIXI.Graphics();
    this.lineMaskEightteen_three.beginFill(0x0033ff);
    this.lineMaskEightteen_three.moveTo(240, 220);
    this.lineMaskEightteen_three.lineTo(240, 900);
    this.lineMaskEightteen_three.lineTo(230 + 194, 900);
    this.lineMaskEightteen_three.lineTo(230 + 194, 240);

    this.lineMaskEightteen_three.lineTo(240 + 900 + 20, 240);
    this.lineMaskEightteen_three.lineTo(240 + 900 + 20, 240 + 206);

    this.lineMaskEightteen_three.lineTo(240 + 200 + 20, 240 + 206);
    this.lineMaskEightteen_three.lineTo(240 + 200 + 20, 240 + 207 + 230);

    this.lineMaskEightteen_three.lineTo(240 + 700 + 20, 240 + 207 + 230);
    this.lineMaskEightteen_three.lineTo(240 + 700 + 20, 900);

    this.lineMaskEightteen_three.lineTo(1480 + 200, 900);
    this.lineMaskEightteen_three.lineTo(1480 + 200, 220);
    this.lineMaskEightteen_three.endFill();
    this.linesContainer.addChild(this.lineMaskEightteen_three);
    this.lineMaskEightteen_three.alpha = 0;

    this.lineMaskEightteen_four = new PIXI.Graphics();
    this.lineMaskEightteen_four.beginFill(0x0033ff);
    this.lineMaskEightteen_four.moveTo(240, 220);
    this.lineMaskEightteen_four.lineTo(240, 900);
    this.lineMaskEightteen_four.lineTo(230 + 194, 900);
    this.lineMaskEightteen_four.lineTo(230 + 194, 240);

    this.lineMaskEightteen_four.lineTo(240 + 1000 + 20, 240);
    this.lineMaskEightteen_four.lineTo(240 + 1000 + 20, 240 + 206);

    this.lineMaskEightteen_four.lineTo(240 + 200 + 20, 240 + 206);
    this.lineMaskEightteen_four.lineTo(240 + 200 + 20, 240 + 207 + 230);

    this.lineMaskEightteen_four.lineTo(240 + 1000 + 20, 240 + 207 + 230);
    this.lineMaskEightteen_four.lineTo(240 + 1000 + 20, 900);

    this.lineMaskEightteen_four.lineTo(1480 + 200, 900);
    this.lineMaskEightteen_four.lineTo(1480 + 200, 220);
    this.lineMaskEightteen_four.endFill();
    this.linesContainer.addChild(this.lineMaskEightteen_four);
    this.lineMaskEightteen_four.alpha = 0;

    this.lineMaskEightteen_five = new PIXI.Graphics();
    this.lineMaskEightteen_five.beginFill(0x0033ff);
    this.lineMaskEightteen_five.moveTo(240, 220);
    this.lineMaskEightteen_five.lineTo(240, 900);
    this.lineMaskEightteen_five.lineTo(230 + 194, 900);
    this.lineMaskEightteen_five.lineTo(230 + 194, 240);

    this.lineMaskEightteen_five.lineTo(240 + 700 + 20, 240);
    this.lineMaskEightteen_five.lineTo(240 + 700 + 20, 240 + 206);

    this.lineMaskEightteen_five.lineTo(240 + 200 + 20, 240 + 206);
    this.lineMaskEightteen_five.lineTo(240 + 200 + 20, 240 + 207 + 230);

    this.lineMaskEightteen_five.lineTo(240 + 1200 + 20, 240 + 207 + 230);
    this.lineMaskEightteen_five.lineTo(240 + 1200 + 20, 240 + 207);

    this.lineMaskEightteen_five.lineTo(240 + 700 + 20, 240 + 207);
    this.lineMaskEightteen_five.lineTo(240 + 700 + 20, 240);

    // this.lineMaskEightteen_five.lineTo(240 + 420 + 165 + 400 + 30 + 20-625, 240+207);

    // this.lineMaskEightteen_five.lineTo(240 + 420 + 165 + 400 + 30 + 20-625, 240+207+220);
    this.lineMaskEightteen_five.lineTo(1480 + 12, 240);
    this.lineMaskEightteen_five.lineTo(1480 + 12, 900);

    this.lineMaskEightteen_five.lineTo(1480 + 200, 900);
    this.lineMaskEightteen_five.lineTo(1480 + 200, 220);
    this.lineMaskEightteen_five.endFill();
    this.linesContainer.addChild(this.lineMaskEightteen_five);
    this.lineMaskEightteen_five.alpha = 0;

    //----special masks 19

    this.lineMaskNineteen_three = new PIXI.Graphics();
    this.lineMaskNineteen_three.beginFill(0x0033ff);
    this.lineMaskNineteen_three.moveTo(240, 220);
    this.lineMaskNineteen_three.lineTo(240, 900);
    this.lineMaskNineteen_three.lineTo(230 + 194, 900);
    this.lineMaskNineteen_three.lineTo(230 + 194, 240);

    this.lineMaskNineteen_three.lineTo(240 + 700 + 20, 240);
    this.lineMaskNineteen_three.lineTo(240 + 700 + 20, 240 + 207);

    this.lineMaskNineteen_three.lineTo(240 + 200 + 20, 240 + 206);
    this.lineMaskNineteen_three.lineTo(240 + 200 + 20, 240 + 206 + 230);

    this.lineMaskNineteen_three.lineTo(240 + 1000 + 20, 240 + 207 + 230);
    this.lineMaskNineteen_three.lineTo(240 + 1000 + 20, 900);

    this.lineMaskNineteen_three.lineTo(1480 + 200, 900);
    this.lineMaskNineteen_three.lineTo(1480 + 200, 220);
    this.lineMaskNineteen_three.endFill();
    this.linesContainer.addChild(this.lineMaskNineteen_three);
    this.lineMaskNineteen_three.alpha = 0;

    this.lineMaskNineteen_four = new PIXI.Graphics();
    this.lineMaskNineteen_four.beginFill(0x0033ff);
    this.lineMaskNineteen_four.moveTo(240, 220);
    this.lineMaskNineteen_four.lineTo(240, 900);
    this.lineMaskNineteen_four.lineTo(230 + 194, 900);
    this.lineMaskNineteen_four.lineTo(230 + 194, 240);

    this.lineMaskNineteen_four.lineTo(240 + 1000 + 20, 240);
    this.lineMaskNineteen_four.lineTo(240 + 1000 + 20, 240 + 206);

    this.lineMaskNineteen_four.lineTo(240 + 200 + 20, 240 + 206);
    this.lineMaskNineteen_four.lineTo(240 + 200 + 20, 240 + 207 + 230);

    this.lineMaskNineteen_four.lineTo(240 + 1000 + 20, 240 + 207 + 230);
    this.lineMaskNineteen_four.lineTo(240 + 1000 + 20, 900);

    this.lineMaskNineteen_four.lineTo(1480 + 200, 900);
    this.lineMaskNineteen_four.lineTo(1480 + 200, 220);
    this.lineMaskNineteen_four.endFill();
    this.linesContainer.addChild(this.lineMaskNineteen_four);
    this.lineMaskNineteen_four.alpha = 0;

    this.lineMaskNineteen_five = new PIXI.Graphics();
    this.lineMaskNineteen_five.beginFill(0x0033ff);
    this.lineMaskNineteen_five.moveTo(240, 220);
    this.lineMaskNineteen_five.lineTo(240, 900);
    this.lineMaskNineteen_five.lineTo(230 + 194, 900);
    this.lineMaskNineteen_five.lineTo(230 + 194, 240);

    this.lineMaskNineteen_five.lineTo(240 + 700 + 20, 240);
    this.lineMaskNineteen_five.lineTo(240 + 700 + 20, 240 + 207);

    this.lineMaskNineteen_five.lineTo(240 + 200 + 20, 240 + 206);
    this.lineMaskNineteen_five.lineTo(240 + 200 + 20, 240 + 206 + 230);

    this.lineMaskNineteen_five.lineTo(240 + 1200 + 20, 240 + 207 + 230);
    this.lineMaskNineteen_five.lineTo(240 + 1200 + 20, 240 + 207);

    this.lineMaskNineteen_five.lineTo(240 + 700 + 20, 240 + 207);
    this.lineMaskNineteen_five.lineTo(240 + 700 + 20, 240);

    // this.lineMaskNineteen_five.lineTo(240 + 420 + 165 + 400 + 30 + 20-625, 240+207);

    // this.lineMaskNineteen_five.lineTo(240 + 420 + 165 + 400 + 30 + 20-625, 240+207+220);
    this.lineMaskNineteen_five.lineTo(1480 + 12, 240);
    this.lineMaskNineteen_five.lineTo(1480 + 12, 900);

    this.lineMaskNineteen_five.lineTo(1480 + 200, 900);
    this.lineMaskNineteen_five.lineTo(1480 + 200, 220);
    this.lineMaskNineteen_five.endFill();
    this.linesContainer.addChild(this.lineMaskNineteen_five);
    this.lineMaskNineteen_five.alpha = 0;

    ///---special 20
    this.lineMaskTwenty_three = new PIXI.Graphics();
    this.lineMaskTwenty_three.beginFill(0x0033ff);
    this.lineMaskTwenty_three.moveTo(240, 220);
    this.lineMaskTwenty_three.lineTo(240, 900);
    this.lineMaskTwenty_three.lineTo(230 + 194, 900);
    this.lineMaskTwenty_three.lineTo(230 + 194, 240);

    this.lineMaskTwenty_three.lineTo(
      240 + 420 + 165 + 400 + 30 + 20 - 200,
      240
    );
    this.lineMaskTwenty_three.lineTo(
      240 + 420 + 165 + 400 + 30 + 20 - 200,
      240 + 206
    );
    this.lineMaskTwenty_three.lineTo(
      240 + 420 + 165 + 400 + 30 + 20 - 625+20,
      240 + 206
    );

    this.lineMaskTwenty_three.lineTo(
      240 + 420 + 165 + 400 + 30 + 20 - 625+20,
      240 + 207 + 230
    );
    this.lineMaskTwenty_three.lineTo(
      240 + 420 + 165 + 400 + 30 + 20 - 200,
      240 + 207 + 230
    );
    this.lineMaskTwenty_three.lineTo(240 + 420 + 165 + 400 + 30 + 20-200, 900);

    this.lineMaskTwenty_three.lineTo(1480 + 200, 900);
    this.lineMaskTwenty_three.lineTo(1480 + 200, 220);
    this.lineMaskTwenty_three.endFill();
    this.linesContainer.addChild(this.lineMaskTwenty_three);
    this.lineMaskTwenty_three.alpha = 0;

    this.lineMaskTwenty_four = new PIXI.Graphics();
    this.lineMaskTwenty_four.beginFill(0x0033ff);
    this.lineMaskTwenty_four.moveTo(240, 220);
    this.lineMaskTwenty_four.lineTo(240, 900);
    this.lineMaskTwenty_four.lineTo(230 + 194, 900);
    this.lineMaskTwenty_four.lineTo(230 + 194, 240);

    this.lineMaskTwenty_four.lineTo(240 + 420 + 165 + 400 + 30 + 20, 240);
    this.lineMaskTwenty_four.lineTo(240 + 420 + 165 + 400 + 30 + 20, 240 + 207);
    this.lineMaskTwenty_four.lineTo(
      240 + 420 + 165 + 400 + 30 + 20 - 625+20,
      240 + 206
    );

    this.lineMaskTwenty_four.lineTo(
      240 + 420 + 165 + 400 + 30 + 20 - 625+20,
      240 + 206 + 230
    );
    this.lineMaskTwenty_four.lineTo(
      240 + 420 + 165 + 400 + 30 + 20,
      240 + 207 + 230
    );
    this.lineMaskTwenty_four.lineTo(240 + 420 + 165 + 400 + 30 + 20, 900);

    this.lineMaskTwenty_four.lineTo(1480 + 200, 900);
    this.lineMaskTwenty_four.lineTo(1480 + 200, 220);
    this.lineMaskTwenty_four.endFill();
    this.linesContainer.addChild(this.lineMaskTwenty_four);
    this.lineMaskTwenty_four.alpha = 0;

    this.lineMaskTwenty_five = new PIXI.Graphics();
    this.lineMaskTwenty_five.beginFill(0x0033ff);
    this.lineMaskTwenty_five.moveTo(240, 220);
    this.lineMaskTwenty_five.lineTo(240, 900);
    this.lineMaskTwenty_five.lineTo(230 + 194, 900);
    this.lineMaskTwenty_five.lineTo(230 + 194, 240);

    this.lineMaskTwenty_five.lineTo(240 + 700 + 20, 240);
    this.lineMaskTwenty_five.lineTo(240 + 700 + 20, 240 + 206);

    this.lineMaskTwenty_five.lineTo(240 + 500 + 20, 240 + 206);
    this.lineMaskTwenty_five.lineTo(240 + 500 + 20, 240 + 207 + 230);

    this.lineMaskTwenty_five.lineTo(240 + 900 + 20, 240 + 207 + 230);
    this.lineMaskTwenty_five.lineTo(240 + 900 + 20, 240 + 207);

    this.lineMaskTwenty_five.lineTo(240 + 700 + 20, 240 + 207);
    this.lineMaskTwenty_five.lineTo(240 + 700 + 20, 240);

    // this.lineMaskTwenty_five.lineTo(240 + 420 + 165 + 400 + 30 + 20-625, 240+207);

    // this.lineMaskTwenty_five.lineTo(240 + 420 + 165 + 400 + 30 + 20-625, 240+207+220);
    this.lineMaskTwenty_five.lineTo(1480 + 12, 240);
    this.lineMaskTwenty_five.lineTo(1480 + 12, 900);

    this.lineMaskTwenty_five.lineTo(1480 + 200, 900);
    this.lineMaskTwenty_five.lineTo(1480 + 200, 220);
    this.lineMaskTwenty_five.endFill();
    this.linesContainer.addChild(this.lineMaskTwenty_five);
    this.lineMaskTwenty_five.alpha = 0;



      //---
    this.lineMaskTwentyThree_five = new PIXI.Graphics();
    this.lineMaskTwentyThree_five.beginFill(0x0033ff);
    this.lineMaskTwentyThree_five.moveTo(240, 220);
    this.lineMaskTwentyThree_five.lineTo(240, 900);
    this.lineMaskTwentyThree_five.lineTo(230 + 194, 900);
    this.lineMaskTwentyThree_five.lineTo(230 + 194, 240);

    this.lineMaskTwentyThree_five.lineTo(240 + 700 + 20, 240);
    this.lineMaskTwentyThree_five.lineTo(240 + 700 + 20, 240 + 206);

    this.lineMaskTwentyThree_five.lineTo(240 + 500 + 20, 240 + 206);
    this.lineMaskTwentyThree_five.lineTo(240 + 500 + 20, 240 + 207 + 230);

    this.lineMaskTwentyThree_five.lineTo(240 + 900 + 20, 240 + 207 + 230);
    this.lineMaskTwentyThree_five.lineTo(240 + 900 + 20, 240 + 207);

    this.lineMaskTwentyThree_five.lineTo(240 + 700 + 20, 240 + 207);
    this.lineMaskTwentyThree_five.lineTo(240 + 700 + 20, 240);
    this.lineMaskTwentyThree_five.lineTo(1480 + 12, 240);
    this.lineMaskTwentyThree_five.lineTo(1480 + 12, 900);

    this.lineMaskTwentyThree_five.lineTo(1480 + 200, 900);
    this.lineMaskTwentyThree_five.lineTo(1480 + 200, 220);
    this.lineMaskTwentyThree_five.endFill();
    this.linesContainer.addChild(this.lineMaskTwentyThree_five);
    this.lineMaskTwentyThree_five.alpha = 0;



    this.lineMaskTwentyThree_three = new PIXI.Graphics();
    this.lineMaskTwentyThree_three.beginFill(0x0033ff);
    this.lineMaskTwentyThree_three.moveTo(240, 220);
    this.lineMaskTwentyThree_three.lineTo(240, 900);
    this.lineMaskTwentyThree_three.lineTo(230 + 194, 900);
    this.lineMaskTwentyThree_three.lineTo(230 + 194, 240);

    this.lineMaskTwentyThree_three.lineTo(1050 + 14, 240);
    this.lineMaskTwentyThree_three.lineTo(1050 + 14, 240 + 206);

    this.lineMaskTwentyThree_three.lineTo(240 + 500 + 20, 240 + 206);
    this.lineMaskTwentyThree_three.lineTo(240 + 500 + 20, 240 + 207 + 230);

    this.lineMaskTwentyThree_three.lineTo(1050 + 14, 240 + 207 + 230);
    // this.lineMaskTwentyThree_three.lineTo(240 + 900 + 20, 240 + 207);

    // this.lineMaskTwentyThree_three.lineTo(240 + 700 + 20, 240 + 207);
    // this.lineMaskTwentyThree_three.lineTo(240 + 700 + 20, 240);
    // this.lineMaskTwentyThree_three.lineTo(1260 + 14, 240);
    this.lineMaskTwentyThree_three.lineTo(1050 + 14, 900);

    this.lineMaskTwentyThree_three.lineTo(1480 + 200, 900);
    this.lineMaskTwentyThree_three.lineTo(1480 + 200, 220);
    this.lineMaskTwentyThree_three.endFill();
    this.linesContainer.addChild(this.lineMaskTwentyThree_three);
    this.lineMaskTwentyThree_three.alpha = 0;

  

      this.lineMaskTwentyThree_four = new PIXI.Graphics();
      this.lineMaskTwentyThree_four.beginFill(0x0033ff);
      this.lineMaskTwentyThree_four.moveTo(240, 220);
      this.lineMaskTwentyThree_four.lineTo(240, 900);
      this.lineMaskTwentyThree_four.lineTo(230 + 194, 900);
      this.lineMaskTwentyThree_four.lineTo(230 + 194, 240);
  
      this.lineMaskTwentyThree_four.lineTo(240 + 700 + 20, 240);
      this.lineMaskTwentyThree_four.lineTo(240 + 700 + 20, 240 + 206);
  
      this.lineMaskTwentyThree_four.lineTo(240 + 500 + 20, 240 + 206);
      this.lineMaskTwentyThree_four.lineTo(240 + 500 + 20, 240 + 207 + 230);
  
      this.lineMaskTwentyThree_four.lineTo(240 + 900 + 20, 240 + 207 + 230);
      this.lineMaskTwentyThree_four.lineTo(240 + 900 + 20, 240 + 207);
  
      this.lineMaskTwentyThree_four.lineTo(240 + 700 + 20, 240 + 207);
      this.lineMaskTwentyThree_four.lineTo(240 + 700 + 20, 240);
      this.lineMaskTwentyThree_four.lineTo(1260 + 14, 240);
      this.lineMaskTwentyThree_four.lineTo(1260 + 14, 900);
  
      this.lineMaskTwentyThree_four.lineTo(1480 + 200, 900);
      this.lineMaskTwentyThree_four.lineTo(1480 + 200, 220);
      this.lineMaskTwentyThree_four.endFill();
      this.linesContainer.addChild(this.lineMaskTwentyThree_four);
      this.lineMaskTwentyThree_four.alpha = 0;

    this.lineMasks = [
      this.lineMaskTwo,
      this.lineMaskThree,
      this.lineMaskFour,
      this.lineMaskFive,
    ];

    for (var i = 0; i < this.winLineslines.length; i++) {
      // this.winLineslines[i].filters=[this.colorFilters];
      // this.winLineslines[i].alpha=1
    }
  };
  
  private highlightWinline(winline: number, length: number) {
    for (var i = 0; i < length; i++) {
      this.winframes[winline][i].alpha = 1;
      this.winframes[winline][i].gotoAndStop(this.winFramStyleIndex);
      this.winframes[winline][i].loop = true;
      this.winframes[winline][i].gotoAndPlay(0);
    }

    this.linesContainer.mask = null;
    this.winlines[winline][0].alpha = 1;
    this.winlines[winline][1].alpha = 1;
    //--automatic mask setup
    this.linesContainer.mask = this.lineMasks[length - 2];
    //exceptions


    
    if (winline == 22 || winline == 23 ) {
      if (length == 5) {
        this.linesContainer.mask = this.lineMaskTwentyThree_five;
      }
      if (length == 4) {
        this.linesContainer.mask = this.lineMaskTwentyThree_four;
      }
      if (length == 3) {
        this.linesContainer.mask = this.lineMaskTwentyThree_three;
      }
    }

    if (winline == 21 ||winline == 20 ) {
      if (length == 5) {
        this.linesContainer.mask = this.lineMaskTwenty_five;
      }
      if (length == 4) {
        this.linesContainer.mask = this.lineMaskTwenty_four;
      }
      if (length == 3) {
        this.linesContainer.mask = this.lineMaskTwenty_three;
      }
    }

    


    if (winline == 19) {
      if (length == 5) {
        this.linesContainer.mask = this.lineMaskNineteen_five;
      }
      if (length == 4) {
        this.linesContainer.mask = this.lineMaskNineteen_four;
      }

      if (length == 3) {
        this.linesContainer.mask = this.lineMaskNineteen_three;
      }
    }

    if (winline == 18) {
      if (length == 5) {
        this.linesContainer.mask = this.lineMaskEightteen_five;
      }
      if (length == 4) {
        this.linesContainer.mask = this.lineMaskEightteen_four;
      }

      if (length == 3) {
        this.linesContainer.mask = this.lineMaskEightteen_three;
      }
    }
    // let data=this.activeGameData.GameContext();
    // data.winCombinations.
    // console.log(this.activeGameData.winlinnesList)

    for (let i = 0; i < this.activeGameData.winlinnesList.length; i++) {
      if(this.activeGameData.winlinnesList[i].lineNumber==winline)
      {
        // console.log(this.activeGameData.winlinnesList[i].win.credits.amount)
        this.winValueDisplay.text="\n "+"   "+convertCreditsFromServerToClient(this.activeGameData.winlinnesList[i].win.credits.amount).toFixed(2) +"   "+"\n ";
      }
      
    }
    // console.log(winline,length)//------------------------------rewrite the winine ;
    this.winlineNumberL.text = "  " + winline + "  ";
    this.winlineNumberR.text = "  " + winline + "  ";

    //-set height
    let row1 = [2, 4, 6, 10, 14, 18,22,24];
    let row2 = [1, 8, 9, 12, 13, 16, 17, 20,21,];
    let row3 = [3, 5, 7, 11, 15, 19,23,25];
    let posYindex = 0;

    let posYHeight1=215;
    let posYHeight2= 430;
    let posYHeight3=645;

    if (row1.indexOf(winline) >= 0) {
      //-set pos row 1 //-
      posYindex =posYHeight1;
    } else if (row2.indexOf(winline) >= 0) {
      //set pos =2
      posYindex = posYHeight2
    } else if (row3.indexOf(winline) >= 0) {
      //set post =3
      posYindex = posYHeight3;
    }
    this.winlineNumberL.y =  posYindex;
    this.winlineNumberR.y = this.winlineNumberL.y;

    // this.winValueDisplay.y= this.winlineNumberR.y;

    if (winline == 6) {
      this.winlineNumberR.y =posYHeight3;
    }

    if (winline == 7) {
      this.winlineNumberR.y = posYHeight1;

    }

 this.winLinesNumberBG_R.y=this.winlineNumberR.y;
 this.winLinesNumberBG_L.y=this.winlineNumberL.y;

    //---position for winDiplsy 

    //-centered
    // let rr1=[2,5,9,14,17,18];
    // let rr2=[1,6,7,11,10,12,13,];
    // let rr3=[3,4,8,15,16,19,20];
    //first
    let rr1=[2,4,6,10,14,18];
    let rr2=[1,8,9,12,13,16,17,20];
    let rr3=[3,5,7,11,15,19];
    this.winValueDisplayTween.stop();
    this.winValueDisplayTween.reset();
    this.winValueDisplayTween.start();
    this.winValueDisplay.x= this.activeGameData.size[0]/2-215*2;
    let offsetVert=50
    if (rr1.indexOf(winline) >= 0) { this.winValueDisplay.y=  this.activeGameData.size[1] / 2-200+offsetVert;}
    if (rr2.indexOf(winline) >= 0) { this.winValueDisplay.y= this.activeGameData.size[1] / 2+ 15+offsetVert;}
    if (rr3.indexOf(winline) >= 0) { this.winValueDisplay.y=  this.activeGameData.size[1] / 2+230+offsetVert;}




    // this.animateScaleSymbol()
  }

  //   private animateScaleSymbol=():void=>

  //   {
  // ///-------------------------------------------------animate
  // this.activeGameData.mainGame.getColumn().getSprite().setWinTweenActive(true)
  // setWinTweenActive

  //   }

  // highlightScatter(winline:number,index:number)
  // {
  // 		// this.winframes[winline][index].alpha=1;//dont displays winlines
  // 		// this.winframes[winline][index].gotoAndPlay(0);
  // 		// this.colorFilters.hue(this.colorFiltersAngles[0],false);
  // }

  //toggle diffrent winlines
  private startTicker = (): void => {
    this.activeGameData.playable;
    this.switchTimer = 5000;
    this.totalCycles = this.key.length;
    // console.log("totalCycle",this.totalCycles,this.activeGameData.playable);
    this.currentCycle = 0;

    this.swapTicker.add((_delta: number) => {
      if (Date.now() - this.switchTimer > this.switchSpeed) {
        if (this.currentCycle < this.totalCycles) {

          if (this.counter < this.totalCycles) {
            
    this.setWinlinesNumVisible(true);
            // this.activeGameData.sound.play("winline");
            this.activeGameData.NewWinSound.play("winline");
            this.activeGameData.environment.playSpeakerFx();
            // console.log("ring")
          }
   
          this.swapHide(); //hide if previously highlighting any winline
          this.highlightWinline(
            this.key[this.currentCycle],
            this.value[this.currentCycle]
          );

          // highlightOrbsonWinline(
          //   this.value[this.currentCycle],
          //   this.activeGameData
          // );
          this.currentCycle++;
          this.counter++;
        } else {
          if (this.totalCycles > 1) {
            if (this.counter < this.totalCycles) {
              // this.activeGameData.sound.play("winline");
              this.activeGameData.NewWinSound.play("winline");
              this.activeGameData.environment.playSpeakerFx();
            }


            this.currentCycle = 0;
            this.swapHide(); //hide if previously highlighting any winline
            this.highlightWinline(
              this.key[this.currentCycle],
              this.value[this.currentCycle]
            );
            // highlightOrbsonWinline(
            //   this.value[this.currentCycle],
            //   this.activeGameData
            // );

            this.currentCycle++;
            this.counter++;
          }
        }

        this.switchTimer = Date.now();
      }
    });

    this.swapTicker.start();
  };
  private swapHide = (): void => {
    for (var i = 0; i < this.winLinesframes.length; i++) {
      this.winLinesframes[i].alpha = 0;

      this.winLinesframes[i].gotoAndStop(0);
    }

    for (var i = 1; i < this.winlines.length; i++) {
      this.winlines[i][0].alpha = 0;
      this.winlines[i][1].alpha = 0;
    }
  };
  
  public setWinlineToDisplay = (): void => {
    // this.activeGameData

    let winlineComb=GetWinlineCombo(this.activeGameData);
   
    if (winlineComb != undefined) {
      // console.log(winlineComb)

      for (let i = 0; i < this.activeGameData.winlinnesList.length; i++) {
        // const element = array[i];
        this.key.push(this.activeGameData.winlinnesList[i].lineNumber);
        this.value.push(this.activeGameData.winlinnesList[i].count);
      }

    }


    this.counter = 0;
    if (this.activeGameData.winlinnesList.length > 0) {
      this.startTicker();
    }
  };
  private setWinlinesNumVisible = (bool: boolean): void => {
    let newA = bool ? 1 : 0;

    this.winlineNumberL.alpha = newA;
    this.winlineNumberR.alpha = newA;
    
    this.winLinesNumberBG_L.alpha = newA;
    this.winLinesNumberBG_R.alpha = newA;
  
    this.winValueDisplayTween.stop();
    this.winValueDisplayTween.reset();
    this.winValueDisplay.alpha=newA;
  };
  public sethidden = (): void => {
    this.swapHide();
    this.key = [];
    this.value = [];
    this.setWinlinesNumVisible(false);
    this.swapTicker.stop();
  };
  public getSwitchSpeed = (): number => {
    return this.switchSpeed;
  };
  public setWinFrameStyle = (index: number): void => {
    this.winFramStyleIndex = index;
  };
}
